module.exports = __webpack_public_path__ + "static/media/1POLICY8.97038fb3.jpg";